export const platforms = {
  ios: "iOS",
  android: "Android",
  other: "other",
};
